import React from "react";

export default function CopyIcon({ className }) {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g clipPath="url(#clip0_713_3780)">
          <path
            d="M10.5 10.5H11.5C12.6046 10.5 13.5 9.60457 13.5 8.5V4.5C13.5 3.39543 12.6046 2.5 11.5 2.5H7.5C6.39543 2.5 5.5 3.39543 5.5 4.5V5.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.5 5.5H4.5C3.39543 5.5 2.5 6.39543 2.5 7.5V11.5C2.5 12.6046 3.39543 13.5 4.5 13.5H8.5C9.60457 13.5 10.5 12.6046 10.5 11.5V7.5C10.5 6.39543 9.60457 5.5 8.5 5.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_713_3780">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
